import A from 'const/actionTypes'

const compareFollowThroughPowerRankings = (a, b) => {
  let sortOrder = 0

  if (a.mmr < b.mmr) {
    sortOrder = -1
  } else if (a.mmr > b.mmr) {
    sortOrder = 1
  }

  return sortOrder
}

export default (currentState, action) => {
  let updatedState = Object.assign({}, currentState)

  switch (action.type) {
    case A.CLEAR_FOLLOW_THROUGH_POWER_RANKINGS:
      updatedState = {}
      break
    case A.DELETE_FOLLOW_THROUGH_POWER_RANKING:
      updatedState[action.gamerId] = null
      break
    case A.SET_FOLLOW_THROUGH_POWER_RANKINGS:
      const updatedFollowThroughPowerRankings = {}
      const newFollowThroughPowerRankings = action.followThroughPowerRankings

      const sortedFollowThroughPowerRankings =
        Object.keys(newFollowThroughPowerRankings).map(newFollowThroughPowerRankingId => {
          const newFollowThroughPowerRanking = newFollowThroughPowerRankings[newFollowThroughPowerRankingId]
          newFollowThroughPowerRanking.tempId = newFollowThroughPowerRankingId
          return newFollowThroughPowerRanking
        }).sort(compareFollowThroughPowerRankings)

      sortedFollowThroughPowerRankings.map(sortedFollowThroughPowerRanking => {
        const followThroughPowerRankingId = sortedFollowThroughPowerRanking.tempId
        delete sortedFollowThroughPowerRanking.tempId

        updatedFollowThroughPowerRankings[followThroughPowerRankingId] = sortedFollowThroughPowerRanking
      })

      updatedState = updatedFollowThroughPowerRankings
      break
  }

  return updatedState
}



// WEBPACK FOOTER //
// ./src/app/reducers/followThroughPowerRankings.js